import React from 'react';
import { MatchNotFoundProps } from './types';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { EmojiWrapper } from './MatchNotFound.style';

const MatchNotFound: React.FC<MatchNotFoundProps> = ({
  theme = 'light',
  size = 1,
}) => {
  return (
    <Container>
      <Col>
        <EmojiWrapper>
          <span className="d-flex justify-content-center emoji">🔍</span>
        </EmojiWrapper>
        <Row>
          <span className="d-flex justify-content-center text-light">
            Nie znaleźliśmy meczu
          </span>
        </Row>
        <Row>
          <span className="d-flex justify-content-center text-light">
            Sprawdź identyfikator i spróbuj ponownie.
          </span>
        </Row>
      </Col>
    </Container>
  );
};

export default MatchNotFound;
